<template>
	<div>
		<Layout :navFixed="false" :loading="loading" :invert="true">
			<div class="container mt-5" v-if="!loading">
				<div class="row">
					<div class="col">
						<h1 class="title text-center mb-2">
							<strong>
								Preguntas frecuentes
							</strong>
						</h1>
					</div>
				</div>

				<div class="row mt-4">
					<div class="col-12">
						<div class="p-4 mt-4 ">
							<b-list-group class="group bg-transparent border-none">
								<b-list-group-item class="bg-transparent " v-for="(item, i) in list" :key="i">
									<div class="group-item-head" v-b-toggle="`collapse-${i}`">
										<div>{{ item.question }}</div>

										<div class="icon icon-chevron-down"></div>
									</div>
									<b-collapse :id="`collapse-${i}`" class="mt-2">
										<div v-html="item.answer" class="p-2"></div>
									</b-collapse>
								</b-list-group-item>
							</b-list-group>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import Layout from '@/components/Layout'
import gql from 'graphql-tag'

export default {
	name: 'Faqs',
	metaInfo() {
		return {
			title: 'Preguntas frecuentes',
		}
	},
	components: {
		Layout,
	},
	data() {
		return {
			list: [],
			loading: true,
		}
	},
	beforeMount() {
		this.load()
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query {
							faqs {
								data {
									id
									question
									answer
								}
							}
						}
					`,

					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.list = data.faqs.data
					this.loading = false
				})
				.catch((err) => {
					console.log(err)
					// this.$router.push('/')
				})
		},
	},
}
</script>

<style scoped>
.group ::v-deep .list-group-item {
	border: none;
	border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.group-item-head {
	font-size: 17px;
	padding: 3px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.group-item-head .fa {
	font-size: 12px;
}

.not-collapsed .icon {
	transform: rotate(180deg);
}
</style>
